import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dynamic%20sports%20stadium%20atmosphere%20with%20dramatic%20stadium%20lights%20and%20energy%2C%20warm%20golden%20and%20deep%20red%20accents%2C%20abstract%20artistic%20sports%20motion%20blur%20effect%2C%20dark%20background%20with%20vibrant%20colored%20light%20streaks%2C%20epic%20cinematic%20composition%2C%20professional%20sports%20photography%20style%20with%20dramatic%20lighting%2C%20no%20text%20or%20logos&width=1800&height=900&seq=hero-bg-kaiyun-01&orientation=landscape"
        alt="开云体育平台 - 专业体育竞技服务"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      <div className="relative z-10 w-full max-w-[900px] mx-auto px-4 md:px-6 text-center pt-16">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/20 border border-primary-500/30 text-primary-300 text-sm font-medium mb-6">
          <i className="ri-verified-badge-line"></i>
          官方正版 · 全球数千万用户信赖之选
        </div>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight">
          开云体育平台
        </h1>
        <p className="mt-4 text-xl md:text-2xl text-background-200 font-heading">
          顶级体育竞技体验 · 从这里开始
        </p>
        <p className="mt-5 text-sm md:text-base text-background-300/80 max-w-[600px] mx-auto leading-relaxed">
          覆盖足球、篮球、网球、电竞等数百种赛事，提供实时赔率、极速入金提款、全天候客服支持，开云体育平台为您带来专业、安全、便捷的体育竞技服务
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
          <Link
            to="/about"
            className="px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            立即注册 · 领新人优惠
          </Link>
          <Link
            to="/category/football"
            className="px-8 py-3.5 rounded-lg border border-background-300/40 text-background-100 font-medium text-sm hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            浏览赛事
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
        <div className="flex items-center justify-center gap-8 mt-10 flex-wrap">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50 font-heading">3,860+</p>
            <p className="text-xs text-background-400 mt-1">每日赛事</p>
          </div>
          <div className="w-px h-10 bg-background-300/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50 font-heading">2,800万+</p>
            <p className="text-xs text-background-400 mt-1">全球用户</p>
          </div>
          <div className="w-px h-10 bg-background-300/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50 font-heading">99.9%</p>
            <p className="text-xs text-background-400 mt-1">服务可用率</p>
          </div>
          <div className="w-px h-10 bg-background-300/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50 font-heading">7×24h</p>
            <p className="text-xs text-background-400 mt-1">全天候客服</p>
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}